// Copyright (c) 2016 Deere & Company

import GeneralSettings from '../../user/general-settings/state-connector';

export default {
    component: GeneralSettings,
    name: 'GENERAL',
    path: 'general'
};



// WEBPACK FOOTER //
// ./src/routes/settings/general.js